(ns beicon.impl.rxjs
  (:require ["rxjs" :as rx]))

(goog/exportSymbol "rxjsMain" rx)
